import { Injectable, inject } from "@angular/core";
import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { SystemConfig } from "@app/models/rest/system-config";
import { SystemConfigService } from "@app/services/hal/system-config-service";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class SystemConfigStore extends RealTimeDataStore<SystemConfig> {
  constructor() {
    const systemConfigService = inject(SystemConfigService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(systemConfigService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("SystemConfig");
  }
}
